import React from 'react';
import Icon from '@ant-design/icons';

const ReplyArrowSvg = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 17 4 12l5-5" />
    <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
  </svg>
);

export const ReplyIcon = (props) => <Icon component={ReplyArrowSvg} {...props} />;
